import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "services/apiList";

const initialState = {
  loading: false,
  data: [],
  total_page: 1,
  current_page: 1,
  search: "",
  role: "all",
  headers: [
    "№",
    "Хэрэглэгчийн нэр",
    "Овог",
    "Нэр",
    "Регистр",
    "Имэйл",
    "Утас",
    "Эрх",
  ],
  role_list: [
    { id: "all", text: "Бүгд" },
    { id: "teachers", text: "Багш нар" },
    { id: "managers", text: "Менежерүүд" },
    { id: "students", text: "Сурагчид" },
    { id: "parents", text: "Асран хамгаалагчид" },
    { id: "chef", text: "Тогооч" },
    { id: "food_technologist", text: "Хоол технологич" },
  ],
  error: "",
};

export const fetchUsers = createAsyncThunk(
  "get/users",
  async (_, { getState }) => {
    const { search, role, current_page } = getState().user;
    let params = `isPaginated=1&search=${search}&role=${role}&page=${current_page}`;

    if (role === "all") {
      params = `isPaginated=1&search=${search}&page=${current_page}`;
    }

    const response = await axios.get(`${ApiList.userUrl}?${params}`);
    return response.data;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.current_page = 1;
      state.search = action.payload;
    },
    setRole: (state, action) => {
      state.current_page = 1;
      state.role = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.current_page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (action.payload.result) {
          state.data = action.payload.result.result || [];
          state.total_page = action.payload.result.count || 1;
        }
        state.error = "";
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export const { setSearch, setRole, setCurrentPage } = userSlice.actions;
export default userSlice.reducer;
